import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';

const SelectSubEstadoNapNoDisponible = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    defaultProps,
    isMulti
}) => {
    const [selectedValue, setSelectedValue] = useState(value);
    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };
    const options = [
        {
            value: 'AUSENCIA',
            label: 'AUSENCIA',
        },
        {
            value: 'CABLE EN MAL ESTADO',
            label: 'CABLE EN MAL ESTADO',
        },
        {
            value: 'CAJA EN MAL ESTADO',
            label: 'CAJA EN MAL ESTADO',
        },
        {
            value: 'FALTA DE MANTENIMIENTO',
            label: 'FALTA DE MANTENIMIENTO',
        },
        {
            value: 'PUERTOS COMPLETOS',
            label: 'PUERTOS COMPLETOS',
        },
        {
            value: 'SIN HERRAJES',
            label: 'SIN HERRAJES',
        },
        {
            value: 'SIN POTENCIA',
            label: 'SIN POTENCIA',
        },
    ];

    useEffect(() => {
        if (typeof value === 'string') {
            setSelectedValue(options.find((opt) => opt.value === value));
        }else if(Array.isArray(value)){
            setSelectedValue(value.map(va=>{
                const item = options.find(it=>it.value === va);
                if(item){
                    return {
                        value:item.value,
                        label:item.label
                    };
                }
                return null
            }))
        }
    }, [value]);
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#000',
            background: state.isSelected ? '#0364ff' : '#fff',
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: '#0364ff',
                borderRadius: 5
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        control: (styles)=>({
            ...styles,
            borderRadius: 7,
            borderColor: 'gray'
        })
    }), [])
    return (
        <Select
            {...defaultProps}
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isMulti={isMulti}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
        />
    );
};

SelectSubEstadoNapNoDisponible.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectSubEstadoNapNoDisponible;